import { coreOrganizationsAllGetAsyncSlice } from './get';
import { CoreOrganizationsAllName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';

export const coreOrganizationsAllRemoveSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreOrganizationsAllName,
	state: coreOrganizationsAllGetAsyncSlice.asyncState,
	target: (data: { organizationId: number }) => (organization) => organization.id === data.organizationId
});
